// Canonical list of search fields exposed by scite's search UI. Imported by
// SearchBuilder.js (the user-facing field selector) and by boolean-search-prompt.js
// (the natural-language → boolean query LLM prompt) so both stay in sync.

export const FIELDS = [
  {
    label: 'All fields',
    value: 'all'
  },
  {
    label: 'Title',
    value: 'title'
  },
  {
    label: 'Abstract',
    value: 'abstract'
  },
  {
    label: 'Citation Statements',
    value: 'citations.snippet'
  },
  {
    label: 'Citation Section',
    value: 'citations.section'
  },
  {
    label: 'Cited Document (DOI)',
    value: 'citations.target_doi'
  },
  {
    label: 'Author',
    value: 'authors.author_name'
  },
  {
    label: 'Affiliation',
    value: 'authors.affiliations'
  },
  {
    label: 'Topic',
    value: 'topics.display_name'
  },
  {
    label: 'MeSH Descriptor',
    value: 'mesh_types.descriptor_name'
  },
  {
    label: 'MeSH Qualifier',
    value: 'mesh_types.qualifier_name'
  },
  {
    label: 'Year',
    value: 'year'
  },
  {
    label: 'Journal',
    value: 'journal'
  },
  {
    label: 'ISSN',
    value: 'issns'
  },
  {
    label: 'Publisher',
    value: 'publisher'
  },
  {
    label: 'Publication Type',
    value: 'normalized_types'
  },
  {
    label: 'Pubchem substances by name',
    value: 'pubchem_compounds.compound_title'
  },
  {
    label: 'Pubchem substances by CID',
    value: 'pubchem_compounds.compound_id'
  }
]

export const PLACEHOLDERS = {
  all: 'Search all fields',
  title: 'Search title',
  abstract: 'Search abstract',
  'citations.snippet': 'Search citation statements',
  'citations.section': 'Search citation section such as introduction, results, discussion, etc.',
  'citations.target_doi': 'Search cited document (DOI)',
  'authors.author_name': 'Search author',
  'authors.affiliation': 'Search affiliation',
  'topics.display_name': 'Search topic',
  'mesh_types.descriptor_name': 'Search MeSH descriptor',
  'mesh_types.qualifier_name': 'Search MeSH qualifier',
  year: 'Search year',
  journal: 'Search journal',
  issns: 'Search ISSN',
  publisher: 'Search publisher',
  normalized_types: 'Search publication type such as Article, Book, Preprint or Review',
  'pubchem_compounds.compound_title': 'Search PubChem substances by name',
  'pubchem_compounds.compound_id': 'Search PubChem substances by compound id'
}
